import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLike, meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PackOperatorParameters} from "#template/nodes/geometry-graph/attribute/pack-operator/geometry-pack-operator-node"
import {GeometryPackOperatorNode, packOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/pack-operator/geometry-pack-operator-node"

export type MeshGeometryPackOperatorParameters = PackOperatorParameters<MeshGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryPackOperatorParameters> = {
    nodeClass: "MeshGeometryPackOperator",
    validation: {
        parameters: packOperatorParametersSchema(meshGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryPackOperator extends GeometryPackOperatorNode<2, MeshGeometryAttributeLikeNode> implements MeshGeometryAttributeLikeNode {
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
